import { FluentProvider, Toaster } from '@fluentui/react-components';
import { useEffect, type PropsWithChildren } from 'react';

import { useThemeStore } from './themeStore';
import { resolveTheme } from './caredocsTheme';

export function ThemeProvider({ children }: PropsWithChildren) {
  const themeName = useThemeStore((s) => s.themeName);
  const theme = resolveTheme(themeName);

  useEffect(() => {
    document.documentElement.dataset.theme = themeName;
    document.documentElement.style.colorScheme = themeName;
  }, [themeName]);

  return (
    <FluentProvider theme={theme} applyStylesToPortals>
      {children}
      <Toaster toasterId="hub-global-toaster" position="top-end" />
    </FluentProvider>
  );
}
